export default {
    featureRow: 'feature-row',
};
//# sourceMappingURL=FeatureRow.datahooks.js.map